import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ScrollerService {
	/**
	 * Scrollable element
	 */
	private _element: any;

	constructor() {}

	/**
	 * Set scrollable element once
	 */
	public init(element: any) {
		if (!this._element) {
			this._element = element;
		}
	}

	/**
	 * Scroll to top off the page
	 */
	public scrollTop() {
		if (this._element && this._element.scrollTo && typeof this._element.scrollTo === 'function') {
			this._element.scrollTo(0, 0);
		}
	}
}
